import { TeDropdown, TeDropdownOption, TeSearch } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { countries } from '@topcon/topcon-utils';

import { Country } from '../types/geolocation.types';

interface CountryDropdownProps {
  selectedCountry: string;
  onSelectCountry: (country?: Country) => void;
  disabled?: boolean;
  loading?: boolean;
  dropdownPosition?: 'up' | 'down';
  required?: boolean;
  readonly?: boolean;
  clearable?: boolean;
}

const CountryDropdown = ({
  onSelectCountry,
  disabled,
  loading,
  selectedCountry,
  dropdownPosition = 'up',
  required = true,
  clearable = false,
  readonly = false,
}: CountryDropdownProps) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const { t } = useTranslation();
  return (
    <TeDropdown
      placeholderText={
        loading ? t('searchCountryLoadingPlaceholder') : t('searchCountryPlaceholder')
      }
      size="s"
      grow
      valueByDefault={selectedCountry}
      value={selectedCountry}
      techange={(e) => {
        setSearchValue('');

        const country = countries.getCountry(e.value);
        if (required && !country) return;
        onSelectCountry(country);
      }}
      required={required}
      style={{ flex: 1 }}
      up={dropdownPosition === 'up'}
      disabled={disabled}
      loading={loading}
      readonly={readonly}
      persistent={!clearable}
    >
      <TeSearch
        slot="search"
        techange={(e) => setSearchValue(e.target.value.toLowerCase())}
        value={searchValue}
        clearable={clearable}
        teclear={() => onSelectCountry(undefined)}
      />
      {Array.from(
        new Set(
          countries.list.sort((a, b) => a.name.localeCompare(b.name)).map((country) => country.code)
        )
      ).map((code) => {
        const country = countries.getCountry(code);
        return (
          <TeDropdownOption
            imageSource={countries.getFlagSVG(code)}
            key={`${code}-${country?.name}`}
            text={country?.name}
            value={code}
            hidden={!country?.name.toLowerCase().includes(searchValue)}
          />
        );
      })}
    </TeDropdown>
  );
};

export { CountryDropdown, type Country };
